var _svg;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

// This file is automatically generated from generateIcons.js
import * as React from 'react';
import IconContainer from '../IconContainer.js';

function ExternalLinkIcon(props) {
  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, props, {
    children: _svg || (_svg = /*#__PURE__*/React.createElement("svg", {
      width: "100%",
      height: "100%",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/React.createElement("path", {
      d: "M20.398 21c.332 0 .602-.375.602-.837V13.75a.75.75 0 00-1.5 0v5.685h-15V4.565h5.717a.783.783 0 000-1.565H3.602C3.269 3 3 3.375 3 3.837v16.326c0 .462.27.837.602.837h16.796z",
      fill: "currentColor"
    }), /*#__PURE__*/React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M23 10a1 1 0 11-2 0V4.414L10.414 15A1 1 0 019 13.586L19.586 3H14a1 1 0 110-2h8a1 1 0 011 1v8z",
      fill: "currentColor"
    })))
  }));
}

export default ExternalLinkIcon;